import PropTypes from 'prop-types';
import { DIAGRAM_TEMPLATES } from '../data/diagramTemplates';

function TemplatePanel({ onLoadTemplate }) {
  return (
    <div className="template-grid">
      {DIAGRAM_TEMPLATES.map(template => (
        <div
          key={template.type}
          className="template-item"
          onClick={() => onLoadTemplate(template.template)}
        >
          <h4 className="template-item__name">{template.name}</h4>
          <p className="template-item__description">{template.description}</p>
        </div>
      ))}
    </div>
  );
}

TemplatePanel.propTypes = {
  onLoadTemplate: PropTypes.func.isRequired
};

export default TemplatePanel;
